import { render, staticRenderFns } from "./sub-scenario-cargo.vue?vue&type=template&id=4c90bc46"
import script from "./sub-scenario-cargo.vue?vue&type=script&lang=js"
export * from "./sub-scenario-cargo.vue?vue&type=script&lang=js"
import style0 from "./sub-scenario-cargo.vue?vue&type=style&index=0&id=4c90bc46&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports